import { useLayoutEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';

export const DraggableBox = ({children, defaultPosition = 'center', initialMargin = 16, id, className, initialPosition, setDragPosition, onDragStart, onDragEnd, onClick, setHovered, style={}}) => {
  const floatRef = useRef(null)

  const [position, setPosition] = useState({x: 0, y: 0})  

  const handleDragging = (_, data) => {
    setPosition({x: data.x, y: data.y})
    if(setDragPosition && typeof setDragPosition === "function"){
      setDragPosition({x: data.x, y: data.y})
    }
  }

  const positionCoordsFinder = (positionName) => {
    switch(positionName){
      case 'bottom-left':
        setPosition({x: initialMargin, y: window.innerHeight - floatRef?.current?.offsetHeight - initialMargin });
        break;
      case 'center':
        setPosition({
          x: (window.innerWidth / 2) - (floatRef?.current?.offsetWidth / 2), 
          y: (window.innerHeight / 2) - (floatRef?.current?.offsetHeight / 2)
          })
        break;
      case 'top-left':
        setPosition({x: initialMargin, y:  initialMargin });
        break;
      case 'top-right':
        setPosition({x: window.innerWidth - floatRef?.current?.offsetWidth - initialMargin, y: initialMargin });
        break;
      case 'bottom-right':
        setPosition({x: window.innerWidth - floatRef?.current?.offsetWidth - initialMargin, y: window.innerWidth - floatRef?.current?.offsetWidth - initialMargin})
        break;
      default:
        break;
    }
  }

  const onContainerClick = () => {
    if(onClick){
      onClick();
    }
  }

  const handleMouseEnter = () => {
    if(setHovered) setHovered(true);
  }

  const handleMouseLeave = () => {
    if(setHovered) setHovered(false);
  }

  useLayoutEffect(() => {
    if(initialPosition?.x && initialPosition.y){
      setPosition(initialPosition)
    }else if(floatRef?.current){
      positionCoordsFinder(defaultPosition)
    }
  },[floatRef, defaultPosition, initialPosition])

  
  return(
    <Draggable bounds='body' 
      onDrag={handleDragging}
      position={position}
      onStart={onDragStart}   // hook into drag start
      onStop={onDragEnd}      // hook into drag end
      cancel=".no-drag"
    >
        <div
          ref={floatRef}
          style={{
            backgroundColor: 'white',
            boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            cursor: 'move',
            zIndex: 1250,
            position: 'fixed',
            overflow: 'hidden',
            ...style
          }}
          className={`no-cursor ${className || ""}`}
          id={id}
          onClick={onContainerClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <span style={{
            width: '100%',
            height: '1rem',
            background: '#f1f1f1',
            backgroundImage: 'radial-gradient(rgb(214 214 214), 1px, transparent 1px)',
            backgroundSize: '6px 6px',
            backgroundRepeat: 'round'
  
          }} className='cursor'></span>
          <div style={{padding: '0.5rem'}}>
            {children}
          </div>
        </div>
    </Draggable>
  )
}